module.exports = __webpack_public_path__ + "static/media/undraw_towing_6yy4.b9d6f3d0.png";